import { render, staticRenderFns } from "./SettingChangePassword.vue?vue&type=template&id=76ddc7e8&"
import script from "./SettingChangePassword.vue?vue&type=script&lang=ts&"
export * from "./SettingChangePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports